import { c as _c } from "react/compiler-runtime";
import useProductListingData from 'hooks/useProductListingData';
import { GET_CATEGORY_PAGE } from 'mocks/queries';
import getVisitorLocationQueryVariables from 'commons/getVisitorLocationQueryVariables';
import useUserLocation from 'global-state/userLocation/useUserLocation';
const clearanceSeoLongDescription = '<h2 class="text-lg font-bold m-0">Style Your Space for Less</h2>' + '<br />' + '<h2 class="text-lg font-bold m-0">Unbeatable Deals on Joybird Furniture</h2>' + 'Welcome to our clearance section, where you\'ll find exceptional discounts on high-quality furniture pieces that elevate your home without breaking the bank. Whether you\'re looking to refresh your living space or furnish an entire room, our clearance furniture offers incredible value and style. From <a href="https://joybird.com/modern/sofas-and-sectionals/">modern sofas</a> and chic <a href="https://joybird.com/dining-room-furniture/">dining sets</a> to elegant <a href="https://joybird.com/beds/">beds</a> and versatile <a href="https://joybird.com/coffee-and-end-tables/">coffee tables</a>, each piece has been thoughtfully selected to help you create the home of your dreams while staying within budget.' + '<br /><br />' + '<h2 class="text-lg font-bold m-0">Joybird Furniture on Sale – Affordable Style, Exceptional Quality</h2>' + 'Our furniture on sale features a diverse range of items perfect for any space. Explore our selection of discounted furniture that combines contemporary design with functionality. Discover everything from cozy couches and stylish <a href="https://joybird.com/chairs/">chairs</a> to decorative <a href="https://joybird.com/pillows/">pillows</a> and trendy <a href="https://joybird.com/ottomans/">ottomans</a>, all at unbeatable prices. This is your opportunity to snag stunning pieces that not only fit your style but also provide comfort and durability for years to come. Don\'t miss out on these limited-time offers!' + '<br /><br />' + '<h2 class="text-lg font-bold m-0">Transform Your Home with Discounted Designs</h2>' + 'At Joybird, we believe that everyone deserves to create a beautiful <a href="https://joybird.com/living-room-furniture/">living space</a>, and our discounted furniture collection makes that possible. Dive into a treasure trove of carefully curated items that are stylish, versatile, and budget-friendly. From eye-catching <a href="https://joybird.com/wall-decor/">wall art</a> to sleek <a href="https://joybird.com/console-and-entry-tables/">media consoles and entry tables</a>, you\'ll find everything you need to bring your vision to life. Our clearance section allows you to mix and match designs and styles, ensuring your home reflects your unique taste without compromising on <a href="https://joybird.com/quality/">quality</a>.';
const useClearancePageData = () => {
  const $ = _c(7);
  const userLocation = useUserLocation();
  const zipCode = userLocation?.zip ?? "";
  const t0 = userLocation?.stateShortName;
  let t1;
  if ($[0] !== t0) {
    t1 = getVisitorLocationQueryVariables(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== zipCode) {
    t2 = {
      variables: {
        slug: "clearance",
        ...t1,
        zipCode
      }
    };
    $[2] = t1;
    $[3] = zipCode;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const pageData = useProductListingData(GET_CATEGORY_PAGE, t2);
  let t3;
  if ($[5] !== pageData) {
    t3 = {
      ...pageData,
      pageName: "Clearance",
      pageLongDescription: clearanceSeoLongDescription,
      pageHtmlTitle: "Clearance Furniture: Discounted Sofas, Tables & More | Joybird",
      pageMetaDescription: "Shop Joybird\u2019s clearance for discounted furniture, including sofas, tables, and more. Find high-quality, stylish pieces at unbeatable prices. Limited stock!"
    };
    $[5] = pageData;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default useClearancePageData;